import {
  CandidateHandicapCase,
  CandidateMilitaryServiceStatus,
  CandidateWorkExperienceStatus,
  EducationExperienceInstitutionLevel,
  type CandidateHandicapCase as CandidateHandicapCaseType,
  type CandidateMilitaryServiceStatus as CandidateMilitaryServiceStatusType,
  type CandidateWorkExperienceStatus as CandidateWorkExperienceStatusType,
  type EducationExperienceInstitutionLevel as EducationExperienceInstitutionLevelType,
} from '@flex-apis/recruiting';

import { RecruitingPeriodType } from '../../job-description';
import { VeteranWhether } from '../constants';

export function isEducationExperienceInstitutionLevel(
  institutionLevel: unknown
): institutionLevel is EducationExperienceInstitutionLevelType {
  return Object.values(EducationExperienceInstitutionLevel).some(
    item => item === institutionLevel
  );
}

export function isCandidateWorkExperienceStatus(
  status: unknown
): status is CandidateWorkExperienceStatusType {
  return Object.values(CandidateWorkExperienceStatus).some(
    item => item === status
  );
}

export const isCandidateMilitaryServiceStatus = (
  status: unknown
): status is CandidateMilitaryServiceStatusType => {
  return Object.values(CandidateMilitaryServiceStatus).some(
    item => item === status
  );
};

export const isCandidateHandicapCase = (
  caseType: unknown
): caseType is CandidateHandicapCaseType => {
  return Object.values(CandidateHandicapCase).some(item => item === caseType);
};

export const isVeteranWhether = (
  veteran: unknown
): veteran is VeteranWhether => {
  return Object.values(VeteranWhether).some(item => item === veteran);
};

export const isRecruitingPeriodType = (
  periodType: unknown
): periodType is RecruitingPeriodType => {
  return Object.values(RecruitingPeriodType).some(item => item === periodType);
};
